import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a2e158c")

_pushScopeId("data-v-5a2e158c")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__body" }
const _hoisted_3 = { class: "schedule__group" }
const _hoisted_4 = {
  key: 1,
  class: "listState"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "icon-clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Aucun match à l'horaire", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheScheduleUpdate = _resolveComponent("TheScheduleUpdate")
  const _component_TheScheduleTable = _resolveComponent("TheScheduleTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.canUpdateSchedule)
          ? (_openBlock(), _createBlock(_component_TheScheduleUpdate, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.emptySchedule)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6
            ]))
          : (_openBlock(), _createBlock(_component_TheScheduleTable, {
              key: 2,
              scrollTo: _ctx.urlDateAnchor,
              filterSetName: _ctx.filterSetName
            }, null, 8, ["scrollTo", "filterSetName"]))
      ])
    ])
  ]))
})